export default "__VITE_ASSET__06c22f2f__"